import ko from '@tko/build.knockout';
import $ from 'jquery';
import Moment from 'moment-timezone';
import _ from 'lodash';
import FormatterCommon from './formatter-common';
import GridFormatterCommon from './grid-formatter-common';
import FilterFormatter from './filter-formatter';
import CommonDialog from '../../components/modal-dialog/common-dialog/common-dialog';
import LoginService from "../../services/login.service";

function AlertGridFormatter(params, observableOptions) {

    var self = this;

    self.observableOptions = observableOptions;

    self.formatterCommon = FormatterCommon;
    self.gridFormatterCommon = new GridFormatterCommon();
    self.filterFormatter = new FilterFormatter();

    self.observableFormattedData = ko.observable({});

    self.subscriptions = [];
}

function ComposeData(sourceList, options, formatters, metadata, currentUserId, self) {
    var headers = metadata.searchgrid.headers;
    var rowProperties = metadata.searchgrid.rowProperties;
    const widths = metadata.searchgrid.columnWidths;

    if (_.isEmpty(sourceList)) {
        return formatters.gridFormatterCommon.composeEmpty(headers, rowProperties, widths);
    }

    var list = [];
    var finalList = [];
    var searchfilter = formatters.filterFormatter.toTypeaheadFilter(_.get(options, 'filter'));
    var modifierCriterion = _.get(options, 'filter.modifier', null);

    sourceList.forEach(function (item) {
        item._createdDate = moment(item.createdDate).format('MM/DD/YYYY hh:mm:ss');
        item._condition = _.get(item, 'conditions[0]', null);

        if (item._condition && (item._condition.indexOf('PacketLoss') >= 0)) {
            item._condition = item._condition.replace('PacketLoss', 'Packet loss') + '%';
        }

        item.status = item.enabled ? "enabled" : "disabled";

        var searchmatch = _.isEmpty(searchfilter) || formatters.filterFormatter.matchAll(item, searchfilter);
        var modifierMatch = _.isEmpty(modifierCriterion) || (modifierCriterion === 'all') || (item.createdBy === ('' + currentUserId));

        if (modifierMatch && searchmatch) {
            list.push({
                name: item.name,
                recipients: item.recipients,
                category: item.type,
                condition: item._condition,
                createdBy: item.createdByName,
                createdDate: item._createdDate,
                status: item.enabled,
                _origObj: item
            });
        }
    });
    var sortableProperties = metadata.searchgrid.sortableProperties;
    var dateTimeKeys = metadata.searchgrid.dateTimeKeys;
    var sortedList = formatters.gridFormatterCommon.sortList(list, sortableProperties, options, null, dateTimeKeys);
    var pagedList = formatters.gridFormatterCommon.pageList(sortedList, options);

    pagedList.forEach(function (item) {
        finalList.push({
            name: formatters.formatterCommon.sanitize(capitalizeFirstLetter(item.name)),
            recipients: formatters.formatterCommon.sanitize(item.recipients),
            category: formatters.formatterCommon.sanitize(capitalizeFirstLetter(item.category)),
            condition: formatters.formatterCommon.sanitize(capitalizeFirstLetter(item.condition)),
            createdBy: formatters.formatterCommon.sanitize(item.createdBy),
            createdDate: formatters.formatterCommon.sanitize(item.createdDate),
            status: item.status,
            edit: '<i style="font-size:15px;" class="fa fa-edit" title="Edit"></i>',
            remove: '<i style="font-size:15px;" class="fa fa-trash" title = "Delete"></i>',
            _origObj: item._origObj,
            _actionCallback: function (index) {
                if (index === 7) {
                    editAlert(this._origObj);
                } else if (index === 8) {
                    removeAlert(this._origObj);
                } else if (index === 6) {
                    enableDisableAlert(this._origObj);
                    self.RefreshData();
                }
            }
        });
    });

    if (_.isEmpty(pagedList)) {
        finalList = formatters.gridFormatterCommon.composeEmpty(headers, rowProperties, widths).rows;
    }

    let tabulatorColumns = metadata.searchgrid.headers.map(function (header, index) {
        let column = {
            field: metadata.searchgrid.rowProperties[index],
            minWidth: 100,
            title: header,
        };
        if (header === 'Created On') {
            // same as datetime formatter in grid-widget
            column.formatter = function(cell) {
                let time = new Moment(new Date(cell.getValue()));
                return time.format('MMMM Do YYYY, h:mm:ss a');
            }
            column.minWidth = 150;
        }
        if (header === 'Status') {
            column.cellClick = function(e, cell) {
                cell.getData()._actionCallback(index);
            };
            column.minWidth = 50;
            column.formatter = function(cell) {
              let item = cell.getData();
              if (cell.getValue()) {
                  cell.getElement().classList.add('enabled');
              } else {
                  cell.getElement().classList.remove('enabled');
              }
              return '<div title="' + (item.status ? 'Enabled' : 'Disabled') + '" class="btn-group" data-toggle="buttons">'
                    + '<div class="btn btn-default btn-xs' + (item.status ? ' green' : '') + '">'
                      + '<input type="checkbox" id="toggle_' + item._origObj.id + '" value="' + (item.status ? '1' : '0') + '"' + (item.status ? ' checked' : '') + '>'
                      + '<span>' + (item.status ? 'Enabled' : 'Disabled') + '</span>'
                    + '</div></div>'
            }
        }

        return column;
    });
    // push edit and delete because they're not in metadata
    tabulatorColumns.push({
      cellClick: function(e, cell) {
          cell.getData()._actionCallback(7);
      },
      field: 'edit',
      formatter: 'html',
      headerSort: false,
      minWidth: 50,
      title: 'Edit'
    });
    tabulatorColumns.push({
      cellClick: function(e, cell) {
          cell.getData()._actionCallback(8);
      },
      field: 'remove',
      formatter: 'html',
      headerSort: false,
      minWidth: 50,
      title: 'Delete'
    });

    return {
        maxCount: list.length,
        rows: finalList,
        tabulatorColumns: tabulatorColumns,
        actionIndexes: [6, 7, 8]
    };
}

function capitalizeFirstLetter(string) {
    return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
}

function editAlert(alertObj) {
    var alertModalVm = ko.dataFor($("#AlertModal")[0]);
    alertModalVm.setAlertForEdit(alertObj);
    $("#AlertModal").modal('show');
}

function removeAlert(alertObj) {
    CommonDialog.confirm('Are you sure you want to delete this alert?').then(function(confirmed) {
        if (confirmed) {
            var alertModalVm = ko.dataFor($("#AlertModal")[0]);

            alertModalVm.removeAlert(alertObj, function () {
                $("#AlertModal").trigger('hidden.bs.modal');
            });
        }
    });
}

function enableDisableAlert(alertObj) {
    var alertModalVm = ko.dataFor($("#AlertModal")[0]);

    alertModalVm.enableDisableAlert(alertObj);
}


AlertGridFormatter.prototype.RefreshData = function () {
    var self = this;

    self.observableFormattedData(ComposeData(
        self.sourceList().alertDefs,
        self.observableOptions(),
        {
            filterFormatter: self.filterFormatter,
            gridFormatterCommon: self.gridFormatterCommon,
            formatterCommon: self.formatterCommon
        },
        self.dataRepository.getAlertsMetadata(),
        self.userId,
        self
    ));
};

AlertGridFormatter.prototype.DataUpdated = function () {
    var self = this;
    self.RefreshData();
};

AlertGridFormatter.prototype.OptionsUpdated = function () {
    var self = this;
    self.RefreshData();
};

AlertGridFormatter.prototype.initialize = function (dataRepository, dataProvider) {
    var self = this;

    self.dataRepository = dataRepository;
    self.userId = LoginService.userObject.userId;


    self.sourceList = dataRepository.orgPreferences;

    if (self.sourceList) {
        self.subscriptions.push(self.sourceList.subscribe(function () {
            self.DataUpdated();
        }));
    }

    self.subscriptions.push(self.observableOptions.subscribe(function () {
        self.OptionsUpdated();
    }));

    //initialize data if it is there, so that if it isn't a 'loading' icon will show on UI
    if (!$.isEmptyObject(self.sourceList())) {
        self.RefreshData();
    }
};

AlertGridFormatter.prototype.getObservableData = function () {
    var self = this;
    return self.observableFormattedData;
};

AlertGridFormatter.prototype.dispose = function () {
    var self = this;
    self.subscriptions.forEach(function (sub) {
        sub.dispose();
    });
};

export default AlertGridFormatter;
